module.exports = __webpack_public_path__ + "img/lakeserenewashington_thumb.5473a55a.jpg";